import { ref, computed } from 'vue'
import { getUserToken, getUserName, destroyUserCredentials } from '@/utils/userCredentials'

const user = ref({
  name: getUserName(),
  token: getUserToken()
})

const logged_in = computed(() => {
  return !!user.value.token && user.value.token !== 'Token not established'
})

function updateUserCredentials(name, token) {
  user.value.name = name
  user.value.token = token
  localStorage.setItem('user_name', name)
  localStorage.setItem('user_token', token)
}

function logoutUser() {
  user.value.name = ''
  user.value.token = 'Token not established'
  destroyUserCredentials()
}

export {
  user,
  logged_in,
  updateUserCredentials,
  logoutUser
}
